export function assertUnhandledCase(v: never): never {
    throw new Error(`Unhandled case ${v}`);
}

export function assertUnhandledStatus(_: never): string {
    return "bg-white";
}
